export const MOBILE_ACTIONS = {
  OPEN_TRAVELLERS: 'OPEN_TRAVELLERS',
  OPEN_CALENDAR: 'OPEN_CALENDAR',
  RESERVE: 'RESERVE',
};

const getCTAButtonVariant = ({
  isPreSearch,
  isOriginSelected,
  isPackageSelected,
  isOccupantsExceeded,
  isPackageAvailable,
}: {
  isPreSearch?: boolean;
  isOriginSelected?: boolean;
  isPackageSelected?: boolean;
  isOccupantsExceeded: boolean;
  isPackageAvailable: boolean;
}) => {
  if (isPreSearch && !isOriginSelected) {
    return {
      text: 'Select your location',
      section: 'flyingFrom',
    };
  }

  if (isPreSearch && isOriginSelected && !isPackageSelected) {
    return {
      text: 'Select package option',
      section: 'package',
    };
  }

  if (isPreSearch && isOriginSelected && isPackageSelected) {
    return {
      text: 'Check availability',
      section: 'room',
      mobileAction: MOBILE_ACTIONS.OPEN_CALENDAR,
    };
  }

  if (!isPreSearch && isOccupantsExceeded) {
    return {
      text: 'Change travellers',
      section: 'room',
      mobileAction: MOBILE_ACTIONS.OPEN_TRAVELLERS,
    };
  }

  if (!isPreSearch && !isPackageAvailable) {
    return {
      text: 'Change dates',
      section: 'room',
      mobileAction: MOBILE_ACTIONS.OPEN_CALENDAR,
    };
  }

  return {
    text: 'Reserve',
    section: 'room',
    mobileAction: MOBILE_ACTIONS.RESERVE,
  };
};

export default getCTAButtonVariant;
